import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import { BoardBeamerView } from './BoardBeamerView.js';
import { applyTheme } from './theme.js';
import './index.css';

// Standard-Theme sofort setzen (kein Aufblitzen vor dem ersten Snapshot).
applyTheme(null);

/** Beamer-Ansicht fürs Q&A-Board über ?board=<code> (öffentlich, ohne Login). */
function detectBoardCode(): string | null {
  const p = new URLSearchParams(location.search).get('board');
  return p ? p.trim().toUpperCase() : null;
}

const boardCode = detectBoardCode();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{boardCode ? <BoardBeamerView code={boardCode} /> : <App />}</React.StrictMode>,
);
